import { _ as _slicedToArray } from '../slicedToArray-45a33045.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef, useState, useEffect, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import { TabOutlineController } from './TabOutlineController.js';
import '../unsupportedIterableToArray-5baf4325.js';
var Overlay = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    parentRef = _ref.parentRef;
  var _useState = useState(document.createElement('div')),
    _useState2 = _slicedToArray(_useState, 1),
    overlay = _useState2[0];
  var parentElement = (parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) || document.body;
  useEffect(function () {
    var style = overlay.style;
    style.position = 'fixed';
    style.overflow = 'visible';
    style.margin = '0';
    style.padding = '0';
    style.zIndex = '100';
    parentElement.append(overlay);
    return function () {
      overlay.remove();
    };
  }, [overlay, parentElement]);
  useLayoutEffect(function () {
    overlay.className = className !== null && className !== void 0 ? className : '';
  }, [className, overlay]);
  useLayoutEffect(function () {
    if (typeof ref === 'function') {
      ref(overlay);
    } else if (ref) {
      Object.assign(ref, {
        current: overlay
      });
    }
  }, [overlay, ref]);
  return children ? /*#__PURE__*/createPortal(jsx(TabOutlineController, {
    children: children
  }), overlay) : null;
});
export { Overlay };